export const ismInitMobileNav = () => {
  const hamburgerButton = document.querySelector('.ism-hamburger');
  const mobileNav = document.querySelector('#mobileSiteNav');
  const overlay = document.createElement('div');
  const headerWrapper = document.getElementById('transparentHeaderWrapper');
  overlay.classList.add('mobile-nav-overlay');
  document.body.appendChild(overlay);

  if (hamburgerButton && mobileNav) {
    hamburgerButton.addEventListener('click', () => {
      hamburgerButton.classList.toggle('active');
      mobileNav.classList.toggle('open');
      overlay.classList.toggle('open');
      document.querySelectorAll('#mobileSiteNav .ism-openMenu.open').forEach((submenu) => {
        submenu.classList.remove('open');
      });

      if (headerWrapper) {
        if (mobileNav.classList.contains('open')) {
          headerWrapper.classList.add('scrolled');
        }
      }
    });

    overlay.addEventListener('click', () => {
      hamburgerButton.classList.toggle('active');
      mobileNav.classList.toggle('open');
      overlay.classList.toggle('open');
    });
  }

  document.querySelectorAll('#mobileSiteNav .ism-openMenu > a').forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();

      // Toggle the dropdown
      const closestOpenMenu = item.closest('.ism-openMenu');
      if (closestOpenMenu) {
        closestOpenMenu.classList.toggle('open');

        // Make parent submenu dropdowns static
        const parentSubmenus = closestOpenMenu.querySelectorAll('.ism-openMenu.open');
        parentSubmenus.forEach((submenu) => {
          if (submenu !== closestOpenMenu) {
            submenu.classList.remove('open');
            submenu.style.position = 'static';
          }
        });
      }

      const navBack = closestOpenMenu.querySelector('.ism-navBack > a');
      if (navBack) {
        navBack.addEventListener('click', () => {
          closestOpenMenu.classList.remove('open');
          closestOpenMenu.style.position = 'static';
        });
      }
    });
  });
};

export const ismInitDesktopNav = () => {
  const topbarHeight = document.querySelector('.ism-TopbarSection')?.offsetHeight || 0;

  window.addEventListener('scroll', () => {
    const headerWrapper = document.getElementById('transparentHeaderWrapper');
    if (headerWrapper) {
      if (window.scrollY > topbarHeight) {
        headerWrapper.classList.add('scrolled');
      } else {
        headerWrapper.classList.remove('scrolled');
      }
    }
  });

  const desktopNavItems = document.querySelectorAll('#mainSiteNav .nav .nav-item.dropdown');

  desktopNavItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      // Add overlay only if it doesn’t already exist
      if (!document.querySelector('.submenu-overlay')) {
        const overlay = document.createElement('div');
        overlay.classList.add('submenu-overlay');
        overlay.style.animation = 'swoosh-in 0.15s ease-out';
        overlay.addEventListener('click', () => {
          document.querySelectorAll('.desktop-nav .has-submenu').forEach((submenuItem) => {
            submenuItem.classList.remove('open');
          });
          overlay.remove();
        });
        document.body.appendChild(overlay);
      }
    });

    item.addEventListener('mouseleave', () => {
      if ([...desktopNavItems].some((navItem) => navItem.matches(':hover'))) {
        return;
      }

      const overlay = document.querySelector('.submenu-overlay');
      if (overlay) {
        overlay.style.animation = 'swoosh-out 0.2s ease-out';
        overlay.addEventListener('animationend', () => {
          if ([...desktopNavItems].some((navItem) => navItem.matches(':hover'))) {
            return;
          }
          overlay.remove();
        });
      }
    });
  });
};
